import React from 'react';
import Styles from './lesson-menu-item-styles.scss';
import classNames from 'classnames';
import { CheckGreen } from '@/presentation/components/icons';
const LessonMenuItem = ({ icon, status = 'blocked', title, iconBackground = 'rgba($invitedText,0.10)', completed = false, onClick = () => {
    console.log('click');
} }) => {
    return (React.createElement("div", { className: classNames([Styles.lessonMenuItemWrap, Styles[status], Styles[completed ? 'completed' : '']]), onClick: onClick },
        React.createElement("div", { className: Styles.icon, style: {
                backgroundColor: iconBackground
            } },
            icon,
            completed && (React.createElement("span", { className: Styles.check },
                React.createElement(CheckGreen, null)))),
        React.createElement("div", { className: Styles.title }, title)));
};
export default LessonMenuItem;
